import { Component, Element, Fragment, Host, Listen, Prop, h } from '@stencil/core';
import { formatHREF } from '../../utils/utils';

@Component({
  tag: 'cradlepoint-nav-main',
  styleUrl: 'nav-main.css',
  shadow: true,
})
export class NavMain {
  @Element() host: HTMLElement;

  @Prop() domain          : string = 'cradlepoint.com';
  @Prop() json            : string;
  @Prop() logo            : string  = 'https://img.cradlepoint.com/auto-mapping-folder/2022/07/cradlepoint-po-ericsson-logo-long-reverse.png';
  @Prop() logoLight       : string;
  @Prop() logoDark        : string;
  @Prop() searchForm      : string;
  @Prop() navLang         : string;
  @Prop() showContact     : boolean = false;
  @Prop() showSearch      : boolean = false;
  @Prop() showLanguageNav : boolean = false;
  @Prop() showSignIn      : boolean = false;
  @Prop() altMobileLayout : boolean = false;
  @Prop() countryCode     : string;
  @Prop() activeLang      : string;
  @Prop() phoneNo         : string;
  @Prop() homeLink        : string;
  @Prop() hoverTextColor  : string = '#1174e6';

  loaded = false;
  isActive = false;
  jsonData = null;
  showIconsWrapper = false;

  getPhoneSVG = (className:string, fillColor:string = '#fff') => {
    return (
      <svg class={className} xmlns="http://www.w3.org/2000/svg" width={29} height={29} preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16" style={{transform: 'rotate(360deg)'}}>
        <path fill="none" stroke={fillColor} stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M1.75 1.75c0 8.5 4 12.5 12.5 12.5v-4l-3.5-1l-1 1.5c-2 0-4.5-2.5-4.5-4.5l1.5-1l-1-3.5zm8 0c2.5 0 4.5 2 4.5 4.5m-4.5-2c1 0 2 1 2 2"></path>
      </svg>
    )
  };

  getSearchSVG = (className:string, fillColor:string = '#fff') => {
    return (
      <svg class={className} width={29} height={29} viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="11" cy="11" r="9.5" stroke={fillColor} stroke-width="3"></circle>
        <rect x="16" y="19.614" width="5" height="13" transform="rotate(-46.2862 16 19.614)" fill={fillColor}></rect>
      </svg>
    )
  }

  getSignInSVG = (fillColor:string = 'white') => {
    return (
      <svg style={{width:'18px'}} data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 16">
        <path style={{strokeWidth: '0px', fill: fillColor}} class="cls-1" fill={fillColor} fill-rule='evenodd' d="M6,0v4h-1V1H1v14h4v-3h1v4H0V0h6ZM9.65,13.35l-5.35-5.36,5.35-5.35.65.71-4.14,4.15h8.84v1H6.21l4.09,4.14-.65.71Z"/>
      </svg>
    )
  }

  getAngleRightSVG = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" height="16" width="10" viewBox="0 0 320 512"><path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/></svg>
    )
  }

  getLinkClass = (title:string, subtitle:string) => {
    let linkClass = `${title} ${subtitle}`;
    return linkClass.replace('-','_').toLowerCase().split(' ').join('_');
  };

  toggleNav = (event: PointerEvent) => {
    event.preventDefault();
    let sr = this.host.shadowRoot;
    let header = sr.querySelector('header');
    this.isActive = !this.isActive;
    this.host.classList.toggle('active');

    if( document.querySelector('body #modal-backDrop') ){
      document.querySelector('body #modal-backDrop').remove();
    }

    if( this.host.classList.contains('active') ){
      let backDrop = document.createElement('div');
      backDrop.setAttribute("id", "modal-backDrop");
      document.querySelector('body').appendChild(backDrop);
    }

    if (!this.isActive) {
      setTimeout(() => {
        header.classList.remove('level-2', 'level-3', 'level-4');
      }, 150);
    }

    document.querySelector(`${this.searchForm}`)?.classList.add('hidden');
    document.querySelector(`${this.navLang}`)?.classList.add('hidden');
  }

  switchColumn2 = (event: PointerEvent) => {
    let sr = this.host.shadowRoot;
    let el = event.composedPath()[0] as HTMLElement;
    let col1As = sr.querySelectorAll('.column-1 li a');
    let col23Items = sr.querySelectorAll('.column-2-3__item');
    let newActiveItem = sr.querySelector(`.column-2-3__item[data-target-name="${el.dataset.target}"]`);
    let header = sr.querySelector('header');

    col1As.forEach(item => item.classList.remove('active'));
    el.classList.add('active');
    col23Items.forEach(item => item.classList.remove('active'));
    newActiveItem.classList.add('active');
    header.classList.contains('mobile') && header.classList.add('level-2');
  }

  switchColumn3 = (event: PointerEvent) => {
    event.preventDefault();
    let sr = this.host.shadowRoot;
    let el = event.composedPath()[0] as HTMLElement;
    let newActiveItem = sr.querySelector(`.sub-menu[data-target-name="${el.dataset.target}"]`);
    let header = sr.querySelector('header');

    if (header.classList.contains('mobile')) {
      header.classList.remove('level-2');
      header.classList.add('level-3');
      newActiveItem.classList.add('active');
    }
  }

  backToLevel1 = () => {
    let sr = this.host.shadowRoot;
    let header = sr.querySelector('header');
    header.classList.contains('mobile') && header.classList.remove('level-2');
  }

  backToLevel2 = () => {
    let sr = this.host.shadowRoot;
    let header = sr.querySelector('header');
    let level3Items = header.querySelectorAll('.column-2 .has-sub-menu .sub-menu');

    header.classList.contains('mobile') && header.classList.remove('level-3');
    header.classList.contains('mobile') && header.classList.add('level-2');
    let level3ItemsTimeout = setTimeout(()=> {
      level3Items.forEach(item => {
        item.classList.remove('active');
      });
      clearTimeout(level3ItemsTimeout);
    }, 500);
  }

  toggleSearch = (event: PointerEvent) => {
    event.preventDefault();
    this.host.classList.remove('active');
    if( !document.querySelector(`${this.searchForm ? this.searchForm : '.search-form-div'}`).classList.contains('hidden') ){
      if( document.querySelector('body #modal-backDrop') ){
        document.querySelector('body #modal-backDrop').remove();
      }
    }else{
      if( document.querySelector('body #modal-backDrop') ){
        document.querySelector('body #modal-backDrop').remove();
      }

      let backDrop = document.createElement('div');
      backDrop.setAttribute("id", "modal-backDrop");
      document.querySelector('body').appendChild(backDrop);
    }

    document.querySelector(`${this.searchForm ? this.searchForm : '.search-form-div'}`)?.classList.toggle('hidden');
    document.querySelector(`${this.navLang}`)?.classList.add('hidden');

  }

  toggleNavLang = (event: PointerEvent) => {
    event.preventDefault();

    if( document.querySelector('body #modal-backDrop') ){
      document.querySelector('body #modal-backDrop').remove();
    }

    if( this.host.querySelector('cradlepoint-nav-lang').classList.contains('hidden') ){
      let backDrop = document.createElement('div');
      backDrop.setAttribute("id", "modal-backDrop");
      document.querySelector('body').appendChild(backDrop);
    }

    this.host.classList.remove('active');
    document.querySelector(`${this.navLang}`)?.classList.remove('hidden');
    document.querySelector(`${this.searchForm ? this.searchForm : '.search-form-div'}`)?.classList.add('hidden');

  }


  async componentWillLoad() {
    if (this.showContact || this.showSearch || this.showLanguageNav || this.showSignIn) {
      this.showIconsWrapper = true;
    }

    if (this.json) {
      return fetch(this.json)
        .then(response => response.json())
        .then(data => {
          this.jsonData = data;
          this.loaded = true;
        })
        .catch(error => console.log(error));
    }

    return null;
  }

  componentDidLoad() {
    (window.innerWidth < 767) && this.host.shadowRoot.querySelector('header').classList.add('mobile');
  }

  @Listen('resize', { target: 'window' })
  handleResize() {
    clearTimeout(resizeTimeout);
    var resizeTimeout = setTimeout(() => {
      if (window.innerWidth < 768) {
        this.host.shadowRoot.querySelector('header').classList.add('mobile');
      } else {
        this.host.shadowRoot.querySelector('header').classList.remove('mobile');
      }
    }, 100);
  }

  render() {
    return (
      <Host
        class={ this.loaded ? 'loaded' : '' }
        style={{
          '--cwc-nav-hover-text-color': this.hoverTextColor,
        }}
      >
        { this.jsonData && (
          <header class={ this.altMobileLayout == true ? 'alt-mobile-layout' : '' }>
            <div class="header-inner">
              <div class="header-inner__left">
                <button
                  class="nav-toggle"
                  aria-expanded={ this.isActive }
                  aria-label="Toggle navigation"
                  onClick={ this.toggleNav }
                >
                  <slot name="icon-toggle-nav"></slot>
                </button>
                <a href={this.homeLink ? this.homeLink : '/'} class="header__logo header__home-link">
                  <slot name="header-logo"></slot>
                </a>
              </div>
              {this.showIconsWrapper && (
                <div class="header-icons-wrapper">
                  {( this.showContact && this.phoneNo ) && (
                    <a href={ 'tel:' + this.phoneNo } class={'header-icons-wrapper__icon header-icons-wrapper__phone'} data-toggle="tooltip" title={this.phoneNo}>
                      <slot name="icon-phone"></slot>
                    </a>
                  )}
                  {this.showSearch && (
                    <a href='#' class={'header-icons-wrapper__icon header-icons-wrapper__search'} onClick={this.toggleSearch}>
                      <slot name="icon-search"></slot>
                    </a>
                  )}
                  {this.showLanguageNav && (
                    <a href='#' class={'header-icons-wrapper__icon header-icons-wrapper__language'} onClick={this.toggleNavLang}>
                      <slot name="icon-globe"></slot>
                      {/* <i class={'languageFlags white-globe hidden'}></i> */}
                      <div class={'map-details'}>
                        <p>{this.countryCode} <svg class={'svg-inline--fa fa-angle-down'} aria-hidden="true" focusable="false" data-prefix="fas" data-icon="angle-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"></path></svg>
                        </p>
                        <span>{this.activeLang}</span>
                      </div>
                    </a>
                  )}
                  {this.showSignIn && (
                    <a href="/sign-in" class={'header-icons-wrapper__icon header-icons-wrapper__sign-in'}>
                      {this.getSignInSVG('white')}
                      <span>SIGN IN</span>
                    </a>
                  )}
                </div>
              )}
            </div>
            <div class="dropdown-container">
              <div class="column-1-container">
                {this.showIconsWrapper && (
                  <div class="icons-wrapper">
                    {( this.showContact && this.phoneNo ) && (
                      <a
                        href={ 'tel:' + this.phoneNo }
                        class={'header-icons-wrapper__icon header-icons-wrapper__phone'}
                        data-toggle="tooltip"
                        title={this.phoneNo}
                      >
                        <slot name="icon-phone-mobile"></slot>
                      </a>
                    )}
                    {this.showSearch && (
                      <a href='#' class={'header-icons-wrapper__icon header-icons-wrapper__search'} onClick={this.toggleSearch}>
                        <slot name="icon-search-mobile"></slot>
                      </a>
                    )}
                    {this.showLanguageNav && (
                      <a href='#' class={'header-icons-wrapper__icon header-icons-wrapper__language'} onClick={this.toggleNavLang}>
                        <slot name="icon-globe-mobile"></slot>
                        <i class={'languageFlags white-globe hidden'}></i>
                        <div class={'map-details'}>
                          <p>{this.countryCode} <svg class={'svg-inline--fa fa-angle-down'} aria-hidden="true" focusable="false" data-prefix="fas" data-icon="angle-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"></path></svg>
                          </p>
                          <span>{this.activeLang}</span>
                        </div>
                      </a>
                    )}
                    {this.showSignIn && (
                      <a href="/sign-in" class={'header-icons-wrapper__icon header-icons-wrapper__sign-in'}>
                        {this.getSignInSVG('white')}
                      </a>
                    )}
                  </div>
                )}
                <ul class="dropdown-column column-1 list-none">
                  {this.jsonData.main_navigation_v2.map((item: { title: string; }, index: number) => {
                    return (
                      <li>
                        <a
                          href="#"
                          data-target={ (item.title.toLowerCase()).split(' ').join('-') }
                          class={`nav_${(item.title.toLowerCase()).split(' ').join('_')} ${index == 0 ? 'active' : ''}`}
                          onClick={this.switchColumn2}
                        >
                          <span>{ item.title }</span> { this.getAngleRightSVG() }
                        </a>
                      </li>
                    );
                  })}
                </ul>
                {this.jsonData.main_navigation_v2[0]['cta'] && (
                  <div class="column-3 type-2 green-cta green-cta__mobile-default">
                    <div class="content-wrapper">
                      {this.jsonData.main_navigation_v2[0]['cta']['title'] && (
                        <Fragment>
                          <h3 class="green-cta__title">{ this.jsonData.main_navigation_v2[0]['cta']['title'] }</h3>
                        </Fragment>
                      )}
                      {this.jsonData.main_navigation_v2[0]['cta']['short_description'] && <p class="green-cta__description">{ this.jsonData.main_navigation_v2[0]['cta']['short_description'] }</p>}
                      {this.jsonData.main_navigation_v2[0]['cta']['button_type'] == 'v1' && this.jsonData.main_navigation_v2[0]['cta']['button'] && (
                        <cradlepoint-button-cta link={formatHREF(this.domain, this.jsonData.main_navigation_v2[0]['cta']['button']['url'] )}>
                          { this.jsonData.main_navigation_v2[0]['cta']['button']['title'] }
                        </cradlepoint-button-cta>
                      )}
                      {this.jsonData.main_navigation_v2[0]['cta']['button_type'] == 'v2' && this.jsonData.main_navigation_v2[0]['cta']['buttons'] && (
                        <ul>
                          {this.jsonData.main_navigation_v2[0]['cta']['buttons'].map((button: { url: string; title: string; }) => {
                            return (
                              <li class="no-icon">
                                <a href={formatHREF(this.domain, button['button']['url'])} target="_self" class="not-button">
                                  { button['button']['title'] }
                                </a>
                              </li>
                            )
                          })}
                        </ul>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div class="dropdown-column column-2-3__container">
                {this.jsonData.main_navigation_v2.map((item: { title: string; modules: any[]; }, index: number) => {
                  return (
                    <div
                      class={ `column-2-3__item ${index == 0 ? 'active' : ''}` }
                      data-target-name={ (item.title.toLowerCase()).split(' ').join('-') }
                    >
                      <div class="mid-container">
                        <a href="#" class="sub-title" onClick={this.backToLevel1}>
                          { this.getAngleRightSVG() }<span>{ item.title }</span>
                        </a>
                        { item.modules.length > 0 && item.modules.map((module) => {
                          if (module.acf_fc_layout == 'cta') {
                            let { hr, icon, short_description, title, link } = module;
                            return (
                              <div class={ `column-2__cta`}>
                                <div class={`column-2__cta-content-wrapper${hr ? '-with-hr' : ''}`}>
                                  {title && <h3 class="column-2__cta-title">{ title }</h3>}
                                  {(icon || short_description) && (
                                    <div class="column-2__cta-content">
                                      { icon && <img src={ icon } alt="icon" width="23" height="23" /> }
                                      { short_description && (
                                        <div style={{
                                          color: 'var(--cwc-color-secondary-900, #242424)'
                                        }} innerHTML={ short_description }></div>
                                      )}
                                    </div>
                                  )}
                                  {link && (
                                    <a class="column-2__cta-link" href={formatHREF(this.domain, link.url)} target={ link.target ? link.target : '_self' }>
                                      {link.title}
                                    </a>
                                  )}
                                </div>
                              </div>
                            );
                          } else {
                            let ulClass = `column-2 list-none _nav_v2_${item.modules[0].acf_fc_layout}`;
                            switch (item.modules[0].acf_fc_layout) {
                              case 'link_title_description_repeater':
                                  ulClass += ' type-2'
                                  break;
                              default:
                                ulClass += ' type-1'
                                break;
                            }
                            switch (item.modules[0].columns) {
                              case "1/3-2/3":
                                ulClass += ' one-third--two-thirds'
                                break;
                              case "2":
                                ulClass += ' two-columns'
                                break;
                            }
                            return (
                              <ul class={ `${ulClass}` }>
                                {(module.acf_fc_layout == 'icon_title_repeater') && module.data.map((subItem: { show_link: any; link: { url: string; title: any; }; icon: string; }) => {
                                  return (
                                    <li>
                                      { subItem.show_link && <Fragment>
                                        <a href={formatHREF(this.domain, subItem.link.url)} class={this.getLinkClass(item.title, subItem.link.title)}>
                                          { subItem.icon && <img src={ subItem.icon } alt={ `${subItem.link.title} icon` } width="23" height="23"></img>}
                                          <span>{subItem.link.title}</span>
                                        </a>
                                      </Fragment> }
                                      { !subItem.show_link && <Fragment>
                                        <h3>
                                          {subItem.link.title}
                                        </h3>
                                      </Fragment> }
                                    </li>
                                  )
                                })}
                                {(module.acf_fc_layout == 'link_title_description_repeater') && module.data.map((subItem: { icon_link_repeater: any[]; link_title: any; link: { url: string; title: any; }; title: any; short_description: string; border_right: any }) => {
                                  let liClass: string | { [className: string]: boolean; }, titleHTML: any;
                                  let dataTarget: string = subItem.title.toLowerCase().split(' ').join('_');

                                  liClass = '';

                                  if (subItem.border_right == true) {
                                    liClass += ' has-border-right';
                                  }

                                  if (subItem.icon_link_repeater.length) {
                                    liClass += ' has-sub-menu';
                                  }

                                  if (subItem.link_title) {
                                    titleHTML = (
                                      <a href={formatHREF(this.domain, subItem.link.url)} target="_self" class={this.getLinkClass(item.title, subItem.link.title)}>
                                        <h3>{ subItem.link.title }</h3>
                                      </a>
                                    )
                                  } else {
                                    titleHTML = <h3 data-target={dataTarget} onClick={this.switchColumn3}>{ subItem.title }</h3>;
                                  }

                                  return (
                                    <li class={ liClass }>
                                      { titleHTML }
                                      { subItem.short_description && <Fragment>
                                        {/* <hr /> */}
                                        <div innerHTML={subItem.short_description}></div>
                                      </Fragment> }
                                      { subItem.icon_link_repeater.length && <Fragment>
                                        <ul class="list-none sub-menu" data-target-name={dataTarget}>
                                          <a href="#" class="sub-title" onClick={this.backToLevel2}>
                                            { this.getAngleRightSVG() }<span>{ subItem.title }</span>
                                          </a>
                                          { subItem.icon_link_repeater.map((iconLinkRepeaterItem: { link: { title: string; url: string; }; icon: string; }) => {
                                            return (
                                              <li>
                                                <a href={formatHREF(this.domain, iconLinkRepeaterItem.link.url)} target="_self" class={ this.getLinkClass(item.title, iconLinkRepeaterItem.link.title) }>
                                                  { iconLinkRepeaterItem.icon && <img src={ iconLinkRepeaterItem.icon } alt="Fixed sites icon" width="23" height="23" /> }
                                                  <span>{ iconLinkRepeaterItem.link.title }</span>
                                                </a>
                                              </li>
                                            )
                                          })}
                                        </ul>
                                      </Fragment> }
                                    </li>
                                  )
                                })}
                              </ul>
                            )
                          }
                        })}
                      </div>
                      {item['cta'] && (
                        <div class="type-2 green-cta">
                          {item['cta']['icon'] && (
                            <div class="img-wrapper">
                              <img src={ item['cta']['icon'] } alt="icon" width="82" height="82" />
                            </div>
                          )}
                          <div class="content-wrapper">
                            {item['cta']['title'] && (
                              <Fragment>
                                <h3>{ item['cta']['title'] }</h3>
                                <hr />
                              </Fragment>
                            )}
                            {item['cta']['short_description'] && <p>{ item['cta']['short_description'] }</p>}
                            {item['cta']['button_type'] == 'v1' && item['cta']['button'] && (
                              <cradlepoint-button-cta link={formatHREF(this.domain, item['cta']['button']['url'])}>
                                { item['cta']['button']['title'] }
                              </cradlepoint-button-cta>
                            )}
                            {item['cta']['button_type'] == 'v2' && item['cta']['buttons'] && (
                              <ul>
                                {item['cta']['buttons'].map((button: { url: string; title: string; }) => {
                                  return (
                                    <li class="no-icon">
                                      <a href={formatHREF(this.domain, button['button']['url'])} target="_self" class="not-button">
                                        { button['button']['title'] }
                                      </a>
                                    </li>
                                  )
                                })}
                              </ul>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
            <div class="search-form-container">
              <slot name="search-form"></slot>
            </div>
            <div class="nav-lang-container">
              <slot name="nav-lang"></slot>
            </div>
          </header>
        )}
      </Host>
    );
  }

}
